import styled from "styled-components";

const SectionWrapper = styled.div`
  position: relative;

  .fixedText {
    position: absolute;
    top: 50%;
    left: 8%;
    transform: translateY(-50%);
    text-align: left;
    z-index: 10; /* Ensure this is above the swiper slides */
    width: 55%;
    max-width: 800px;
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .eyebrow {
      font-size: 12px;
      font-weight: 700;
      color: #D87B1C;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      margin-bottom: 12px;
      display: inline-block;
      background: rgba(216, 123, 28, 0.12);
      padding: 5px 12px;
      border-radius: 4px;
      border: 1px solid rgba(216, 123, 28, 0.3);
    }

    h1 {
      font-weight: 500 !important;
      line-height: 1.3;
      color: #ffffff;
      margin-top: 0px;
      margin-bottom: 15px;
      text-align: left;
      font-size: 38px;
      letter-spacing: -0.01em;
      text-shadow: 0 4px 15px rgba(0, 0, 0, 0.65);

      span.highlight {
        color: #e08320;
        font-weight: 800;
        text-shadow: 0 4px 15px rgba(0, 0, 0, 0.65);
      }

      span.highlight-price {
        color: #e08320;
        font-weight: 800;
        text-shadow: 0 4px 15px rgba(0, 0, 0, 0.65);
      }
    }

    .divider {
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #e08320 0%, #ca6e0f 100%);
      margin-bottom: 25px;
      margin-left: 0;
      border-radius: 2px;
    }

    .action__btns {
      display: flex;
      gap: 16px;
      margin-top: 5px;
      justify-content: flex-start;
      margin-bottom: 5px;

      .linkbtn {
        transition: transform 0.25s ease;
        &:hover {
          transform: translateY(-2px);
        }
      }

      a.btn {
        padding: 12px 26px;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        border-radius: 50px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.25s ease;
      }

      a.btn.btn-default {
        background: linear-gradient(135deg, #e08320 0%, #ca6e0f 100%);
        color: #ffffff;
        border: none;
        &:hover {
          box-shadow: 0 6px 20px rgba(224, 131, 32, 0.35);
          background: linear-gradient(135deg, #ca6e0f 0%, #b85f09 100%);
        }
      }

      a.btn.btn-default.black {
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: #ffffff;
        backdrop-filter: blur(4px);
        &:hover {
          background: #ffffff;
          color: #121212;
          border-color: #ffffff;
          box-shadow: 0 6px 20px rgba(255, 255, 255, 0.2);
        }
      }
    }
  }

  .swiper-slide .hero_slider,
  .hero_slider {
    height: 680px;
    background-size: cover !important;
    background-position: center !important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
  }

  .slide_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.95) 0%,
      rgba(0, 0, 0, 0.8) 35%,
      rgba(0, 0, 0, 0.35) 60%,
      rgba(0, 0, 0, 0) 100%
    );
    z-index: 1;
  }

  /* Custom swiper navigation buttons */
  .swiper-button-next,
  .swiper-button-prev {
    color: #e08320 !important;
    background: rgba(18, 18, 18, 0.45);
    width: 44px;
    height: 44px;
    border-radius: 50%;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
    z-index: 10;

    &:after {
      font-size: 16px;
      font-weight: bold;
    }

    &:hover {
      background: linear-gradient(135deg, #e08320 0%, #ca6e0f 100%);
      color: #ffffff !important;
      border-color: transparent;
      box-shadow: 0 0 15px rgba(224, 131, 32, 0.4);
    }
  }

  @media only screen and (max-width: 1440px) {
    padding: 0px 0;
  }

  @media only screen and (max-width: 991px) {
    .fixedText {
      left: 5%;
      width: 60%;
    }
  }

  @media only screen and (max-width: 767px) {
    padding: 0px 0;

    .swiper {
      width: 100%;
      height: 480px;
    }

    .swiper-button-next,
    .swiper-button-prev {
      display: none !important;
    }

    .swiper-slide .hero_slider,
    .hero_slider {
      height: 480px;
    }

    .slide_overlay {
      background: rgba(0, 0, 0, 0.65);
    }

    .fixedText {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      text-align: center;
      z-index: 10;
      padding: 0 20px;
      border-radius: 0px;
      width: 100%;
      max-width: 100%;
      background: transparent;
      box-shadow: none;
      border: none;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .fixedText .eyebrow {
      font-size: 11px;
      padding: 4px 12px;
      margin-bottom: 10px;
    }

    .fixedText h1 {
      font-size: 24px;
      margin-bottom: 12px;
      line-height: 1.4;
      text-align: center;
    }

    .fixedText .divider {
      margin-bottom: 15px;
      width: 50px;
      height: 2px;
      margin-left: auto;
      margin-right: auto;
    }

    .fixedText .action__btns {
      display: flex !important;
      flex-direction: row;
      gap: 12px;
      width: 100%;
      justify-content: center;
    }

    .fixedText .action__btns .linkbtn {
      flex: 1;
      max-width: 160px;
    }

    .fixedText .action__btns a.btn {
      padding: 11px 12px;
      font-size: 12px;
      width: 100%;
      min-width: auto;
    }

    .fixedText h2 {
      margin-top: 45px;
    }
  }

  @media only screen and (max-width: 480px) {
    .swiper {
      height: 480px;
    }
    .swiper-slide .hero_slider,
    .hero_slider {
      height: 480px;
    }
    .fixedText .action__btns {
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }
    .fixedText .action__btns .linkbtn {
      width: 100%;
      max-width: 240px;
    }
  }

  .btn-default {
    background: linear-gradient(135deg, #e08320 0%, #ca6e0f 100%);
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #D87B1C;
    padding: 10px 20px;
    margin: 6px;
    font-weight: 600;
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(135deg, #ca6e0f 0%, #b85f09 100%);
      color: #ffffff;
    }
  }
  .hero__Area {
    min-height: 80vh;
  }
`;

export const Container = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  padding: 0 24px;

  @media only screen and (max-width: 1200px) {
    padding: 0 20px;
  }
  @media only screen and (max-width: 767px) {
    padding: 0 16px;
    flex-direction: column;
  }
  @media only screen and (max-width: 380px) {
    padding: 0 12px;
  }
`;

export const ImageWrapper = styled.div`
  width: calc(100% - 507px);
  padding-right: 75px;
  position: relative;

  @media only screen and (max-width: 1200px) {
    width: 60%;
    padding-right: 50px;
  }
  @media only screen and (max-width: 991px) {
    padding-right: 0;
  }
  @media only screen and (max-width: 767px) {
    width: 100%;
    padding-right: 0;
    margin-bottom: 30px;
    transform: rotateY(-180deg);
  }
`;

export const TextWrapper = styled.div`
  width: 507px;

  @media only screen and (max-width: 991px) {
    padding-left: 50px;
  }
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    width: 100%;
  }

  h2 {
    @media only screen and (min-width: 1441px) {
      margin-bottom: 60px;
    }
    @media only screen and (min-width: 1440px) {
      margin-bottom: 40px;
    }
    @media only screen and (min-width: 767px) {
      margin-bottom: 30px;
    }
  }

  p {
    margin-bottom: 30px;
  }

  .learn__more-btn {
    margin-top: 20px;
  }
`;

export const CategorySwitcher = styled.div`
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  width: auto;

  .category-pill-wrapper {
    background: rgba(20, 18, 16, 0.45);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    padding: 5px 6px;
    border-radius: 40px;
    display: flex;
    gap: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }

  .cat-tab-btn {
    background: #FAF4EC;
    border: none;
    color: #4A3B32;
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    padding: 6px 20px 6px 7px;
    border-radius: 35px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: all 0.3s ease;
    white-space: nowrap;

    &:hover {
      text-decoration: none;
    }

    .category-tab-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #FCE1C2;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: all 0.3s ease;

      img {
        width: 17px;
        height: 17px;
        display: block;
        object-fit: contain;
      }
    }

    &.hair-btn:not(.active) .category-tab-icon img {
      filter: brightness(0.2) sepia(0.3);
    }

    &.skin-btn:not(.active) .category-tab-icon img {
      filter: none;
    }

    &.active {
      background: linear-gradient(90deg, #E27D09 0%, #EA8E18 100%);
      color: #ffffff;
      font-weight: 700;
      box-shadow: 0px 4px 15px rgba(226, 125, 9, 0.45);

      .category-tab-icon {
        background: #C46808;

        img {
          filter: brightness(0) invert(1);
        }
      }
    }

    &:hover:not(.active) {
      background: #FFFFFF;
      color: #2E231C;
    }
  }

  @media (max-width: 768px) {
    position: absolute;
    top: 18px;
    left: 0;
    right: 0;
    transform: none;
    width: 100%;
    background: transparent;
    padding: 0 16px;
    z-index: 20;
    box-shadow: none;

    .category-pill-wrapper {
      width: 100%;
      padding: 0;
      gap: 10px;
      background: transparent;
      border: 0;
      border-radius: 0;
      box-shadow: none;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
    }

    .cat-tab-btn {
      flex: 1 1 0;
      justify-content: center;
      min-width: 0;
      padding: 7px 14px 7px 7px;
      border-radius: 30px;
      background: #FAF4EC;
      color: #4A3B32;
      font-size: 13.5px;
      font-weight: 600;
      border: none;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
      gap: 7px;

      .category-tab-icon {
        display: inline-flex;
        width: 28px;
        height: 28px;

        img {
          width: 15px;
          height: 15px;
        }
      }

      &.active {
        background: linear-gradient(90deg, #E27D09 0%, #EA8E18 100%);
        color: #ffffff;
        font-weight: 700;
        box-shadow: 0px 4px 15px rgba(226, 125, 9, 0.45);
      }
    }
  }
`;

export default SectionWrapper;
